import request from '@/utils/request'

//获取虚拟仿真实验详情
export function tVrPaperDO(data) {
	return request({
		url: '/simulation/tVrPaperDO',
		method: 'get',
		params: data
	})
}
//查看当前学生成绩
export function getresult(data) {
	return request({
		url: '/simulation/tVrPaperDO/getresult',
		method: 'get',
		params: data
	})
}
//获取虚拟仿真实验列表(分页)-带用户权限
export function getsimulation(data) {
	return request({
		url: '/simulation/vrResourceDeptDO/page',
		method: 'get',
		params: data
	})
}
//查看实验列表
export function getsimulationNoPower(data) {
	return request({
		url: '/simulation/resource/page',
		method: 'get',
		params: data
	})
}
//资源
export function getresource(data) {
	return request({
		url: '/simulation/resource/' + data.libId,
		method: 'get',
		params: data
	})
}
//1.0考核模式进入实验
export function vrPaperUserInit(data) {
	return request({
		url: '/simulation/tVrPaperDO/vrPaperUserInit',
		method: 'post',
		data
	})
}

//获取虚拟仿真实验详情列表(分页)-带组织权限
export function vrDetailPage(data) {
	return request({
		url: '/simulation/vrResourceDeptDO/vrDetailPage',
		method: 'get',
		params: data
	})
}
//学生端-获取虚拟仿真实验详情
export function getResourceDetail(data) {
	return request({
		url: '/simulation/vrResourceDetail/getResourceDetail',
		method: 'get',
		params: data
	})
}

//学生端-获取虚拟仿真实验浏览量
export function getResourceDetailClicks(data) {
	return request({
		url: '/simulation/vrResourceDetail/getResourceDetailClicks',
		method: 'get',
		params: data
	})
}

//查询当前用户是否收藏实验
export function userIsCollection(data) {
	return request({
		url: '/simulation/vrResourceCollection/userIsCollection',
		method: 'get',
		params: data
	})
}
//添加实验收藏
export function userCollectionSave(data) {
	return request({
		url: '/simulation/vrResourceCollection/userCollectionSave',
		method: 'post',
		data
	})
}

//取消实验收藏
export function userCollectionRemove(data) {
	return request({
		url: '/simulation/vrResourceCollection/userCollectionRemove',
		method: 'post',
		data
	})
}

//学生端-获取虚拟实验详情操作次数
export function getResourceDetailRecord(data) {
	return request({
		url: '/simulation/vrResourceDetailRecord/getResourceDetailRecord',
		method: 'get',
		params: data
	})
}
//学生端-保存实验操作次数
export function saveResourceDetailRecord(data) {
	return request({
		url: '/simulation/vrResourceDetailRecord/saveResourceDetailRecord',
		method: 'post',
		params: data
	})
}
//保存实验评分
export function saveResourceScore(data) {
	return request({
		url: '/simulation/vrResourceScore/saveResourceScore',
		method: 'post',
		data
	})
}

//修改实验评分
export function removeResourceScore(data) {
	return request({
		url: '/simulation/vrResourceScore/removeResourceScore',
		method: 'post',
		data
	})
}

//获取实验评分
export function getResourceScore(data) {
	return request({
		url: '/simulation/vrResourceScore/getResourceScore',
		method: 'get',
		params: data
	})
}

//学生端-添加浏览次数
export function clickInsert(data) {
	return request({
		url: '/simulation/vrResourceDetail/clickInsert',
		method: 'get',
		params: data
	})
}
//实验详情考核统计
export function examineStatisticl(data) {
	return request({
		url: '/simulation/detailStatistical/examineStatisticl',
		method: 'get',
		params: data
	})
}
//个人成绩按次数统计
export function personalStatisticl(data) {
	return request({
		url: '/simulation/detailStatistical/personalStatisticl',
		method: 'get',
		params: data
	})
}

//近一周全员成绩最高分前五名统计
export function allStafStatisticl(data) {
	return request({
		url: '/simulation/detailStatistical/allStafStatisticl',
		method: 'get',
		params: data
	})
}

//个人中心-我收藏的实验
export function myVrCollection(data) {
	return request({
		url: '/simulation/vrResourceCollection/myVrCollection',
		method: 'get',
		params: data
	})
}
//个人中心-实验学习模式学习记录
export function personalVrStudyRecord(data) {
	return request({
		url: '/simulation/vrResourceDetailRecord/personalVrStudyRecord',
		method: 'get',
		params: data
	})
}
//个人中心-实验考核模式学习记录+成绩列表
export function personalVrExamineRecord(data) {
	return request({
		url: '/simulation/vrResourceDetailRecord/personalVrExamineRecord',
		method: 'get',
		params: data
	})
}
//2.0实验查看成绩
export function userDataStepList(data) {
	return request({
		url: '/simulation/tVrDataStepDO/userDataStepList',
		method: 'get',
		params: data
	})
}
//1.0实验查看成绩
export function userScoreStepList(data) {
	return request({
		url: '/simulation/tVrPaperDO/getresult',
		method: 'get',
		params: data
	})
}
 
